import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import globalIP from '@/GlobelIP';
// const downloadExcelData = async (
//   data,
//   edata,
//   catappt,
//   cataexcel,
//   excel,
//   watermark,
//   watermarkUrl,
//   mergeImagesWithWatermark,
//   cataName,
//   productdesc,
//   productName,
//   productcategory,
//   productntw,
//   productfinish
// ) => {
//   const attributesToRemove = [
//     'GrossWeight',
//     'SellingPriceUnit',
//     'Variant_Id',
//     'Buyer_Remark',
//     'Product_Remark',
//     'SellingPriceCurrency',
//     'SellingPrice',
//     'ProductTypeName'
//   ];

//   const headerMapping = {
//     id: 'ID',
//     aliascd: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
//     netwgt: 'Net. Wt.',
//     catcd: 'Category',
//     finish: 'Finish',
//     unit: 'Unit',
//     productname: 'Product Name',
//     description: 'Description',
//     len: 'Len',
//     wid: 'Wid',
//     thick: 'Thick'
//     // Add more header mappings as needed
//   };
//   console.log('edata',edata)
//   console.log('data',data)
//   const companyName = catappt[0]?.attributes?.cmpnm || 'Your Company Name';
//   const logoUrl = catappt[0]?.attributes?.Logo?.data?.attributes?.url || '';
//   const excelImage = cataexcel[0]?.attributes?.BannerPath?.data?.attributes?.url;
//   const imag = excelImage ? `${globalIP}${excelImage}` : excel;
//   console.log('imag');
//   console.log(imag);
//   const workbook = new ExcelJS.Workbook();
//   const worksheet = workbook.addWorksheet('Sheet1', {
//     properties: {
//       tabColor: {
//         argb: 'FFC00000' // Adjust tab color as needed
//       }
//     }
//   });
//   // Increase font size and make it bold
//   worksheet.mergeCells('A1:L4');
//   // Add header row
//   if (imag) {
//     const logoResponse = await fetch(imag);
//     const logoImageBuffer = await logoResponse.arrayBuffer();
//     const logoImageId = workbook.addImage({
//       buffer: logoImageBuffer,
//       extension: 'png' // Adjust the image format as needed
//     });
//     // Insert the logo in a cell to the left of the company name cell
//     worksheet.addImage(logoImageId, {
//       tl: { col: 0, row: 0.1 },
//       ext: { width: 1225, height: 80 }
//     });
//   }
//   const desiredColumnOrder = [
//     'id',
//     'Image',
//     'aliascd'
//     // ... (other columns)
//   ];

//   if (productdesc === true) {
//     desiredColumnOrder.push('description');
//   }
//   if (productName === true) {
//     desiredColumnOrder.push('productname');
//   }

//   desiredColumnOrder.push('unit', 'len', 'wid', 'thick');
//   if (productntw === true) {
//     desiredColumnOrder.push('netwgt');
//   }
//   if (productcategory === true) {
//     desiredColumnOrder.push('catcd');
//   }
//   if (productfinish === true) {
//     desiredColumnOrder.push('finish'); // Add 'finish' column if state is true
//   }
//   console.log('data');
//   console.log(data);
//   const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
//   const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
//   worksheet.addRow(headerchange);
//   const headerRow = worksheet.getRow(5); // Assuming the header is in the first row
//   headerRow.height = 30; // Adjust the height as needed
//   headerRow.eachCell((cell, index) => {
//     cell.fill = {
//       type: 'pattern',
//       pattern: 'solid',
//       fgColor: index % 2 === 0 ? { argb: 'D3D3D3' } : { argb: 'D3D3D3' } // Alternate background colors
//     };
//     cell.alignment = { vertical: 'middle', horizontal: 'center' };
//   });
//   worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
//   worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
//   worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
//   worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
//   worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
//   worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B

//   // Fetch and embed images
//   for (const item of data) {
//     const matchingEData = edata.find(eItem => eItem.id == item.CatalogProduct);
//     if (matchingEData && matchingEData.Image) {
//       const imageUrl = matchingEData.Image;
//       // Fetch the image data

//       const response = await fetch(imageUrl);
//       let imageBuffer = await response.arrayBuffer();

//       if (watermark) {
//         const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);

//         // Convert Base64 to ArrayBuffer
//         const response = await fetch(mergedImageBase64);
//         imageBuffer = await response.arrayBuffer();
//       }

//       // Embed the image in the worksheet
//       const imageId = workbook.addImage({
//         buffer: imageBuffer,
//         extension: 'png' // Adjust the image format as needed
//       });
//       const img = new Image();
//       img.src = URL.createObjectURL(new Blob([imageBuffer]));
//       img.onload = () => {
//         const aspectRatio = img.width / img.height;
//         let imgWidth = 100; // Max width of the image
//         let imgHeight = Math.round(100 / aspectRatio);

//         if (imgHeight > 100) {
//           imgHeight = 100;
//           imgWidth = Math.round(100 * aspectRatio);
//         }

//         // Get the last row in the sheet and use that row index to place the image correctly
//         const lastRowIndex = worksheet.rowCount;
//         worksheet.addRow(values);
//         // Set the image in a cell in a new row
//         const rowNumber = worksheet.rowCount;
//         worksheet.addImage(imageId, {
//           tl: { col: 1.3, row: worksheet.rowCount - 0.2 }, // Adjust the column as needed
//           ext: { width: imgWidth, height: imgHeight }
//           // ext: { width: 100, height: 100 } // Adjust the image size as needed
//         });

//         const row = worksheet.getRow(rowNumber);
//         row.height = 100;
//       };
//       let values;

//       if (productdesc === true) {
//         values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null)); // Include all columns
//       } else {
//         values = desiredColumnOrder.map(key =>
//           key !== 'Image' && key !== 'description' ? item[key] : null
//         ); // Exclude 'finish' column if state is false
//       }
//       if (productName === true) {
//         values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null)); // Include all columns
//       } else {
//         values = desiredColumnOrder.map(key =>
//           key !== 'Image' && key !== 'productname' ? item[key] : null
//         ); // Exclude 'finish' column if state is false
//       }
//       if (productcategory === true) {
//         values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null)); // Include all columns
//       } else {
//         values = desiredColumnOrder.map(key =>
//           key !== 'Image' && key !== 'catcd' ? item[key] : null
//         ); // Exclude 'finish' column if state is false
//       }

//       if (productntw === true) {
//         values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null)); // Include all columns
//       } else {
//         values = desiredColumnOrder.map(key =>
//           key !== 'Image' && key !== 'netwgt' ? item[key] : null
//         ); // Exclude 'finish' column if state is false
//       }

//       if (productfinish === true) {
//         values = desiredColumnOrder.map(key => (key !== 'Image' ? item[key] : null)); // Include all columns
//       } else {
//         values = desiredColumnOrder.map(key =>
//           key !== 'Image' && key !== 'finish' ? item[key] : null
//         ); // Exclude 'finish' column if state is false
//       }
//       worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
//         row.eachCell((cell, colNumber) => {
//           cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
//         });
//       });
//     }
//   }
//   await Promise.all(
//     data.map(async item => {
//       const matchingEData = edata.find(eItem => eItem.id == item.CatalogProduct);
//       if (matchingEData && matchingEData.Image) {
//         const imageUrl = matchingEData.Image;
//         try {
//           const response = await fetch(imageUrl);
//           if (!response.ok) throw new Error(`Failed to fetch ${imageUrl}`);
//           const imageBuffer = await response.arrayBuffer();

//           const img = new Image();
//           img.src = URL.createObjectURL(new Blob([imageBuffer]));
//           await new Promise(resolve => (img.onload = resolve));

//           const aspectRatio = img.width / img.height;
//           let imgWidth = 100;
//           let imgHeight = Math.round(100 / aspectRatio);

//           if (imgHeight > 100) {
//             imgHeight = 100;
//             imgWidth = Math.round(100 * aspectRatio);
//           }

//           const imageId = workbook.addImage({
//             buffer: imageBuffer,
//             extension: 'png'
//           });

//           // Add row and image
//           const values = determineValues(item); // Refactor logic for cleaner code
//           worksheet.addRow(values);
//           const rowNumber = worksheet.rowCount;
//           worksheet.addImage(imageId, {
//             tl: { col: 1.3, row: rowNumber - 0.2 },
//             ext: { width: imgWidth, height: imgHeight }
//           });
//           const row = worksheet.getRow(rowNumber);
//           row.height = 100;
//         } catch (error) {
//           console.error(`Error processing image for item ${item.CatalogProduct}:`, error);
//         }
//       }
//     })
//   );
//   const determineValues = item => {
//     return desiredColumnOrder.map(key => {
//       if (key === 'Image') return null;
//       if (!productdesc && key === 'description') return null;
//       if (!productName && key === 'productname') return null;
//       if (!productcategory && key === 'catcd') return null;
//       if (!productntw && key === 'netwgt') return null;
//       if (!productfinish && key === 'finish') return null;
//       return item[key];
//     });
//   };
//   // Generate Excel buffer
//   const excelBuffer = await workbook.xlsx.writeBuffer();
//   // In a browser environment, you can use Blob and FileSaver to save the file
//   const excelData = new Blob([excelBuffer], {
//     type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
//   });
//   // Save the Excel file
//   saveAs(excelData, `${cataName} Excel.xlsx`);
// };
const ip = globalIP;

const downloadExcelData = async (
  data,
  cata,
  catappt,
  cataexcel,
  excel,
  watermark,
  watermarkUrl,
  mergeImagesWithWatermark,
  cataName,
  productdesc,
  productName,
  productcategory,
  productntw,
  productfinish
) => {


  // Check if cata is multidimensional
  const isMultiDimensional = Array.isArray(cata[0]);

  // Function to generate the Excel file
  const generateExcelFile = async (data, i, fileName) => {
    // Ensure cata has valid data before proceeding
    if (!Array.isArray(data) || data.length === 0) {
      console.warn('No valid data found for generating Excel file');
      return;
    }

    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];

    const headerMapping = {
      id: 'ID',
      aliascd: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      netwgt: 'Net. Wt.',
      catcd: 'Category',
      finish: 'Finish',
      unit: 'Unit',
      productname: 'Product Name',
      description: 'Description',
      len: 'Len',
      wid: 'Wid',
      thick: 'Thick'
      // Add more header mappings as needed
    };

    // Prepare Excel workbook and worksheet
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: { argb: 'FFC00000' }
      }
    });

    // Merge cells for header
    worksheet.mergeCells('A1:L4');

    // Add logo if available
    const logoUrl = cataexcel[0]?.attributes?.BannerPath?.data?.attributes?.url;
    const imag = logoUrl ? `${globalIP}${logoUrl}` : excel;

    if (imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'png' // Adjust image format as needed
      });
      worksheet.addImage(logoImageId, {
        tl: { col: 0, row: 0.1 },
        ext: { width: 1225, height: 80 }
      });
    }

    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B
    // Desired column order (add additional logic based on flags)
    const desiredColumnOrder = [
      'id',
      'Image',
      'aliascd'
      // Add other columns based on flag conditions
    ];

    if (productdesc) desiredColumnOrder.push('description');
    if (productName) desiredColumnOrder.push('productname');
    desiredColumnOrder.push('unit', 'len', 'wid', 'thick');
    if (productntw) desiredColumnOrder.push('netwgt');
    if (productcategory) desiredColumnOrder.push('catcd');
    if (productfinish) desiredColumnOrder.push('finish');

    // Map the header row
    const headerRowValues = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerRowValues);

    // Adjust header row height and styling
    const headerRow = worksheet.getRow(5);
    headerRow.height = 30;
    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: index % 2 === 0 ? { argb: 'D3D3D3' } : { argb: 'D3D3D3' }
      };
      cell.alignment = { vertical: 'top', horizontal: 'center' };
    });

    // Add product rows and images
    // Add product rows and images
    const descriptionColumnIndex = desiredColumnOrder.indexOf('description') + 1;
    if (descriptionColumnIndex > 0) {
      worksheet.getColumn(descriptionColumnIndex).alignment = { wrapText: true, vertical: 'top' };
      worksheet.getColumn(descriptionColumnIndex).width = 50; // adjust width as needed
    }

    for (const item of data) {
      if (!item) continue;

      // Prepare the row values based on the selected columns
      const values = desiredColumnOrder.map(key => {
        if (key === 'Image') return null;
        if (!productdesc && key === 'description') return null;
        if (!productName && key === 'productname') return null;
        if (!productcategory && key === 'catcd') return null;
        if (!productntw && key === 'netwgt') return null;
        if (!productfinish && key === 'finish') return null;
        return item[key] || '';
      });

      // Add row (only once)
      const rowNumber = worksheet.rowCount + 1;
      const row = worksheet.addRow(values);

      // Dynamically calculate row height based on description
      let descriptionText = item['description'] || '';
      const columnWidth = worksheet.getColumn(descriptionColumnIndex)?.width || 20;
      const approxCharsPerLine = Math.floor(columnWidth * 1.4);
      const linesNeeded = descriptionText
        .toString()
        .split('\n')
        .reduce((sum, line) => sum + Math.ceil(line.length / approxCharsPerLine), 0);

      row.height = Math.max(linesNeeded * 20, 100); // Minimum 100 for images

      // Safely access matching catalog item
      if (cata && Array.isArray(cata)) {
        let matchingEData = cata.find(eItem => eItem?.id == item?.CatalogProduct);
        if (isMultiDimensional) matchingEData = cata[i].find(eItem => eItem?.id == item?.CatalogProduct);

        if (matchingEData) {
          try {
            let imageUrl = matchingEData?.Image || '';
            let imageBuffer;

            if (watermark) {
              const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
              imageBuffer = await fetch(mergedImageBase64).then(res => res.arrayBuffer());
            } else {
              imageBuffer = await fetch(imageUrl).then(res => res.arrayBuffer());
            }

            const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });

            // Add image to worksheet
            const cellHeight = row.height || 100;
            const maxImageSize = Math.min(100, cellHeight - 10);

            worksheet.addImage(imageId, {
              tl: { col: 1.1, row: rowNumber - 0.9 },
              br: { col: 2.1, row: rowNumber - 0.1 }  // lock image in 1 full cell
            });


          } catch (err) {
            console.error('Image error:', err);
          }
        }
      }
    }


    // Ensure proper cell alignment and wrapping
    worksheet.eachRow({ includeEmpty: true }, (row) => {
      row.eachCell((cell) => {
        cell.alignment = { vertical: 'top', horizontal: 'center', wrapText: true };
      });
    });

    // Generate Excel buffer and save as file
    const excelBuffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    saveAs(blob, fileName);
  };

  // If multidimensional, generate separate Excel files for each sub-array
  if (isMultiDimensional) {
    for (let i = 0; i < cata.length; i++) {
      // Filter out duplicate products from cataloguecatappt based on the provided condition
      const seenProductIds = new Set();
      const filteredData = data.filter(item =>
        cata[i].some(prod =>
          (String(prod.id) === String(item.CatalogProduct) ||
            String(prod.attributes?.ProductId) === String(item.ProductId)) &&
          !seenProductIds.has(item.CatalogProduct) && !seenProductIds.has(item.ProductId) &&
          seenProductIds.add(item.CatalogProduct) // Add product IDs to the Set
        )
      );
      const fileName = `${cataName[i]}.xlsx`;
      await generateExcelFile(filteredData, i, fileName); // Pass filteredData when multidimensional
    }
  } else {
    // If flat array, generate a single Excel file
    const fileName = `${cataName || 'Catalog'}.xlsx`;
    await generateExcelFile(data, 0, fileName); // Pass data if not multidimensional
  }
};



const fetchImage = async (imageUrl) => {
  const response = await fetch(imageUrl);
  if (!response.ok) throw new Error(`Failed to fetch ${imageUrl}`);
  return await response.arrayBuffer();
};

const downloadExcelData2 = async (
  data,
  cata,
  data2,
  watermark,
  watermarkUrl,
  mergeImagesWithWatermark,
  cataName,
  productdesc,
  productName,
  productcategory,
  productntw,
  productfinish
) => {

  // console.log('cata in excel', cata);

  // Check if cata is multidimensional
  const isMultiDimensional = Array.isArray(cata[0]);

  const generateExcelFile = async (data, i, fileName) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.warn('No valid data found for generating Excel file');
      return;
    }

    const attributesToRemove = [
      'GrossWeight',
      'SellingPriceUnit',
      'Variant_Id',
      'Buyer_Remark',
      'Product_Remark',
      'SellingPriceCurrency',
      'SellingPrice',
      'ProductTypeName'
    ];
    const headerMapping = {
      id: 'ID',
      aliascd: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
      netwgt: 'Net. Wt.',
      catcd: 'Category',
      finish: 'Finish',
      unit: 'Unit',
      productname: 'Product Name',
      description: 'Description',
      len: 'Len',
      wid: 'Wid',
      thick: 'Thick'
      // Add more header mappings as needed
    };
    const companyName = data2[0]?.attributes?.cmpnm || 'Your Company Name';
    const logoUrl = data2[0]?.attributes?.Logo?.data?.attributes?.url || '';
    const imag = `${globalIP}${logoUrl}`;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1', {
      properties: {
        tabColor: {
          argb: 'FFC00000' // Adjust tab color as needed
        }
      }
    });
    const companyNameRow = worksheet.addRow([]);
    // Center the text in the cell
    companyNameRow.getCell(1).alignment = { vertical: 'top', horizontal: 'center' };
    // Increase font size and make it bold
    companyNameRow.getCell(1).font = { size: 16, bold: true };
    const conpmayRow = worksheet.getRow(1); // Assuming the header is in the first row
    conpmayRow.height = 20;
    worksheet.mergeCells('A1:L3');
    worksheet.getCell('E1').value = companyName;
    // Add header row

    if (imag) {
      const logoResponse = await fetch(imag);
      const logoImageBuffer = await logoResponse.arrayBuffer();
      const logoImageId = workbook.addImage({
        buffer: logoImageBuffer,
        extension: 'png' // Adjust the image format as needed
      });
      // Insert the logo in a cell to the left of the company name cell
      worksheet.addImage(logoImageId, {
        tl: { col: 1, row: 0.5 },
        ext: { width: 200, height: 40 }
      });
    }
    const desiredColumnOrder = [
      'id',
      'Image',
      'aliascd'
      // ... (other columns)
    ];

    if (productdesc === true) {
      desiredColumnOrder.push('description');
    }
    if (productName === true) {
      desiredColumnOrder.push('productname');
    }

    desiredColumnOrder.push('unit', 'len', 'wid', 'thick');
    if (productntw === true) {
      desiredColumnOrder.push('netwgt');
    }
    if (productcategory === true) {
      desiredColumnOrder.push('catcd');
    }
    if (productfinish === true) {
      desiredColumnOrder.push('finish'); // Add 'finish' column if state is true
    }

    const header = Object.keys(data[0]).filter(key => !attributesToRemove.includes(key));
    const headerchange = desiredColumnOrder.map(key => headerMapping[key] || key);
    worksheet.addRow(headerchange);
    const headerRow = worksheet.getRow(4); // Assuming the header is in the first row
    headerRow.height = 30; // Adjust the height as needed
    headerRow.eachCell((cell, index) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'D3D3D3' }
      };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      cell.border = {
        top: { style: 'medium', color: { argb: '00000000' } }, // Change the color as needed
        left: { style: 'medium', color: { argb: '00000000' } },
        bottom: { style: 'medium', color: { argb: '00000000' } },
        right: { style: 'medium', color: { argb: '00000000' } }
      };
    });
    worksheet.getColumn('B').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('D').width = 30; // Adjust the width as needed for column B
    worksheet.getColumn('E').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('C').width = 10; // Adjust the width as needed for column B
    worksheet.getColumn('K').width = 20; // Adjust the width as needed for column B
    worksheet.getColumn('L').width = 20; // Adjust the width as needed for column B
    // Fetch and embed images
    // Remove this block completely:
    // await Promise.all(
    //   data.map(async (item) => { ... })
    // );

    // Instead, handle row + image in the existing for loop
    const descriptionColumnIndex = desiredColumnOrder.indexOf('description') + 1;
    if (descriptionColumnIndex > 0) {
      worksheet.getColumn(descriptionColumnIndex).alignment = { wrapText: true, vertical: 'top' };
      worksheet.getColumn(descriptionColumnIndex).width = 50; // adjust width as needed
    }
    const IMAGE_SIZE = 100; // Image height & width in pixels

    for (const item of data) {
      try {
        let matchingEData = isMultiDimensional
          ? cata[i].find(eItem => eItem.id == item.CatalogProduct)
          : cata.find(eItem => eItem.id == item.CatalogProduct);

        if (!matchingEData) continue;

        // Fetch image
        let imageBuffer = await fetchImage(matchingEData.Image);
        if (watermark) {
          const mergedImageBase64 = await mergeImagesWithWatermark(matchingEData.Image, watermarkUrl);
          imageBuffer = await fetch(mergedImageBase64).then(res => res.arrayBuffer());
        }

        const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });

        // Prepare row values
        const values = desiredColumnOrder.map(key => (key === 'Image' ? null : item[key] || null));

        // Add row
        const rowNumber = worksheet.rowCount + 1;
        const row = worksheet.addRow(values);
row.eachCell({ includeEmpty: true }, cell => {
  cell.alignment = {
    horizontal: 'center', // ✅ X-axis center
    vertical: 'middle',   // ✅ Y-axis center
    wrapText: true
  };
});
        // --- DESCRIPTION WRAP + ROW HEIGHT ---
        const descriptionColumnIndex = desiredColumnOrder.indexOf('description') + 1;
        let descriptionHeight = 0;

        if (descriptionColumnIndex > 0) {
          const descriptionText = item['description'] || '';
          const columnWidth = worksheet.getColumn(descriptionColumnIndex).width || 50;
          const approxCharsPerLine = Math.floor(columnWidth * 1.4);
          const linesNeeded = descriptionText
            .toString()
            .split('\n')
            .reduce((sum, line) => sum + Math.ceil(line.length / approxCharsPerLine), 0);
          descriptionHeight = linesNeeded * 15; // height needed for description

          worksheet.getColumn(descriptionColumnIndex).alignment = {
            wrapText: true,
            vertical: 'top',
            horizontal: 'left'
          };
        }

        // Set row height as the **larger of image size or description height**
        row.height = Math.max(IMAGE_SIZE, descriptionHeight);

        // --- IMAGE PLACEMENT ---
        worksheet.addImage(imageId, {
          tl: { col: 1.1, row: rowNumber - 1 },
          ext: { width: IMAGE_SIZE, height: IMAGE_SIZE }
        });

      } catch (error) {
        console.error(`Error processing item ${item.CatalogProduct}:`, error);
      }
    }


    // for (const item of data) {
    //   try {
    //     let matchingEData = isMultiDimensional
    //       ? cata[i].find(eItem => eItem.id == item.CatalogProduct)
    //       : cata.find(eItem => eItem.id == item.CatalogProduct);

    //     if (!matchingEData) continue;

    //     // Fetch image
    //     let imageBuffer = await fetchImage(matchingEData.Image);

    //     if (watermark) {
    //       const mergedImageBase64 = await mergeImagesWithWatermark(matchingEData.Image, watermarkUrl);
    //       imageBuffer = await fetch(mergedImageBase64).then(res => res.arrayBuffer());
    //     }

    //     const imageId = workbook.addImage({ buffer: imageBuffer, extension: 'png' });

    //     // Prepare row values (null for Image column)
    //     const values = desiredColumnOrder.map(key => (key === 'Image' ? null : item[key] || null));

    //     // Add row
    //     const rowNumber = worksheet.rowCount + 1;
    //     const row = worksheet.addRow(values);
    //     worksheet.addRow(values);
    //     let descriptionText = item['description'] || '';
    //     const columnWidth = worksheet.getColumn(descriptionColumnIndex).width || 20;
    //     const approxCharPerLine = columnWidth * 1.2; // adjust multiplier if needed
    //     const lines = Math.ceil(descriptionText.length / approxCharPerLine);
    //     const rowHeight = Math.max(lines * 15, 100); // 15 = default Excel row height, min 100 for image
    //     row.height = rowHeight;
    //     // Add image in Column B
    //     worksheet.addImage(imageId, {
    //       tl: { col: 1.2, row: rowNumber - 1 },
    //       ext: { width: 100, height: 100 }
    //     });

    //     worksheet.getRow(rowNumber).height = 100;

    //   } catch (error) {
    //     console.error(`Error processing image for item ${item.CatalogProduct}:`, error);
    //   }
    // }

    // await Promise.all(
    //   data.map(async (item) => {

    //     try {

    //       let matchingEData = cata.find(eItem => eItem.id == item.CatalogProduct);

    //       if (isMultiDimensional) {
    //         matchingEData = cata[i].find(eItem => eItem.id == item.CatalogProduct);
    //       }


    //       // console.log("matchingEData",matchingEData);
    //       if (matchingEData) {

    //         let imageUrl = matchingEData?.Image || "";
    //         let imageBuffer = await fetchImage(imageUrl);

    //         if (watermark) {
    //           const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
    //           imageBuffer = await fetch(mergedImageBase64).then(res => res.arrayBuffer());
    //         }

    //         const imageId = workbook.addImage({
    //           buffer: imageBuffer,
    //           extension: 'png'
    //         });

    //         // Get values for the row
    //         const values = desiredColumnOrder.map(key => {
    //           if (key === 'Image') return null;
    //           return item[key] || null;
    //         });
    //         // Add image to the cell
    //         const rowNumber = worksheet.rowCount + 1;
    //         worksheet.addRow(values); // Add product data first
    //         worksheet.addImage(imageId, {
    //           tl: { col: 1.2, row: rowNumber - 1 }, // Set image in Column B
    //           ext: { width: 100, height: 100 } // Resize the image
    //         });
    //         const row = worksheet.getRow(rowNumber);
    //         row.height = 100;
    //       }
    //     } catch (error) {
    //       console.error(`Error processing image for item ${item.CatalogProduct}:`, error);
    //     }
    //   })
    // );
    const determineValues = item => {
      return desiredColumnOrder.map(key => {
        if (key === 'Image') return null;
        if (!productdesc && key === 'description') return null;
        if (!productName && key === 'productname') return null;
        if (!productcategory && key === 'catcd') return null;
        if (!productntw && key === 'netwgt') return null;
        if (!productfinish && key === 'finish') return null;
        return item[key];
      });
    };
    // Generate Excel buffer
    const excelBuffer = await workbook.xlsx.writeBuffer();
    // In a browser environment, you can use Blob and FileSaver to save the file
    const excelData = new Blob([excelBuffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    });
    // Save the Excel file
    saveAs(excelData, `${fileName} Excel.xlsx`);
  };

  // If multidimensional, generate separate Excel files for each sub-array
  if (isMultiDimensional) {
    for (let i = 0; i < cata.length; i++) {
      // Filter out duplicate products from cataloguecatappt based on the provided condition
      const seenProductIds = new Set();
      const filteredData = data.filter(item =>
        cata[i].some(prod =>
          (String(prod.id) === String(item.CatalogProduct) ||
            String(prod.attributes?.ProductId) === String(item.ProductId)) &&
          !seenProductIds.has(item.CatalogProduct) && !seenProductIds.has(item.ProductId) &&
          seenProductIds.add(item.CatalogProduct) // Add product IDs to the Set
        )
      );
      const fileName = `${cataName[i]}.xlsx`;
      await generateExcelFile(filteredData, i, fileName); // Pass filteredData when multidimensional
    }
  } else {
    // If flat array, generate a single Excel file
    const fileName = `${cataName || 'Catalog'}.xlsx`;
    await generateExcelFile(data, 0, fileName); // Pass data if not multidimensional
  }
};



export { downloadExcelData, downloadExcelData2 };


// const downloadExcelData = async (
//   cata,
//   edata,
//   catappt,
//   cataexcel,
//   excel,
//   watermark,
//   watermarkUrl,
//   mergeImagesWithWatermark,
//   cataName,
//   productdesc,
//   productName,
//   productcategory,
//   productntw,
//   productfinish
// ) => {
//   // Check if cata is multidimensional
//   console.log();

//   const isMultiDimensional = Array.isArray(cata[0]);

//   // Function to generate the Excel file
//   const generateExcelFile = async (data, fileName) => {
//     // Ensure cata has valid data before proceeding
//     if (!Array.isArray(data) || data.length === 0) {
//       console.warn('No valid data found for generating Excel file');
//       return;
//     }

//     const attributesToRemove = [
//       'GrossWeight',
//       'SellingPriceUnit',
//       'Variant_Id',
//       'Buyer_Remark',
//       'Product_Remark',
//       'SellingPriceCurrency',
//       'SellingPrice',
//       'ProductTypeName'
//     ];

//     const headerMapping = {
//       id: 'ID',
//       aliascd: 'Alias Code', // Change "ProductId" to "Alias Code" in the header
//       netwgt: 'Net. Wt.',
//       catcd: 'Category',
//       finish: 'Finish',
//       unit: 'Unit',
//       productname: 'Product Name',
//       description: 'Description',
//       len: 'Len',
//       wid: 'Wid',
//       thick: 'Thick'
//       // Add more header mappings as needed
//     };

//     // Prepare Excel workbook and worksheet
//     const workbook = new ExcelJS.Workbook();
//     const worksheet = workbook.addWorksheet('Sheet1', {
//       properties: {
//         tabColor: { argb: 'FFC00000' }
//       }
//     });

//     // Merge cells for header
//     worksheet.mergeCells('A1:L4');

//     // Add logo if available
//     const logoUrl = cataexcel[0]?.attributes?.BannerPath?.data?.attributes?.url;
//     const imag = logoUrl ? `${globalIP}${logoUrl}` : excel;

//     if (imag) {
//       const logoResponse = await fetch(imag);
//       const logoImageBuffer = await logoResponse.arrayBuffer();
//       const logoImageId = workbook.addImage({
//         buffer: logoImageBuffer,
//         extension: 'png' // Adjust image format as needed
//       });
//       worksheet.addImage(logoImageId, {
//         tl: { col: 0, row: 0.1 },
//         ext: { width: 1225, height: 80 }
//       });
//     }

//     // Desired column order (add additional logic based on flags)
//     const desiredColumnOrder = [
//       'id',
//       'Image',
//       'aliascd'
//       // Add other columns based on flag conditions
//     ];

//     if (productdesc) desiredColumnOrder.push('description');
//     if (productName) desiredColumnOrder.push('productname');
//     desiredColumnOrder.push('unit', 'len', 'wid', 'thick');
//     if (productntw) desiredColumnOrder.push('netwgt');
//     if (productcategory) desiredColumnOrder.push('catcd');
//     if (productfinish) desiredColumnOrder.push('finish');

//     // Map the header row
//     const headerRowValues = desiredColumnOrder.map(key => headerMapping[key] || key);
//     worksheet.addRow(headerRowValues);

//     // Adjust header row height and styling
//     const headerRow = worksheet.getRow(5);
//     headerRow.height = 30;
//     headerRow.eachCell((cell, index) => {
//       cell.fill = {
//         type: 'pattern',
//         pattern: 'solid',
//         fgColor: index % 2 === 0 ? { argb: 'D3D3D3' } : { argb: 'D3D3D3' }
//       };
//       cell.alignment = { vertical: 'middle', horizontal: 'center' };
//     });

//     // Add product rows and images
//     for (const item of data) {
//       if (!item) {
//         console.warn('Skipping undefined item', item);
//         continue;
//       }

//       // Prepare the row values based on the selected columns
//       const values = desiredColumnOrder.map(key => {
//         if (key === 'Image') return null;
//         if (!productdesc && key === 'description') return null;
//         if (!productName && key === 'productname') return null;
//         if (!productcategory && key === 'catcd') return null;
//         if (!productntw && key === 'netwgt') return null;
//         if (!productfinish && key === 'finish') return null;
//         return item[key]; // Return the actual value for the column
//       });

//       // Add row to worksheet
//       worksheet.addRow(values);

//       // Fetch and embed image
//       const matchingEData = edata?.find(eItem => eItem?.id == item?.CatalogProduct);
//       if (matchingEData?.Image) {
//         try {
//           let imageUrl = matchingEData.Image;
//           let imageBuffer;

//           if (watermark) {
//             const mergedImageBase64 = await mergeImagesWithWatermark(imageUrl, watermarkUrl);
//             const response = await fetch(mergedImageBase64);
//             imageBuffer = await response.arrayBuffer();
//           } else {
//             const response = await fetch(imageUrl);
//             imageBuffer = await response.arrayBuffer();
//           }

//           const imageId = workbook.addImage({
//             buffer: imageBuffer,
//             extension: 'png'
//           });

//           // Resize image and add it to the worksheet
//           const img = new Image();
//           img.src = URL.createObjectURL(new Blob([imageBuffer]));
//           await new Promise(resolve => (img.onload = resolve));

//           const aspectRatio = img.width / img.height;
//           let imgWidth = 100;
//           let imgHeight = Math.round(100 / aspectRatio);
//           if (imgHeight > 100) {
//             imgHeight = 100;
//             imgWidth = Math.round(100 * aspectRatio);
//           }

//           worksheet.addImage(imageId, {
//             tl: { col: 1.3, row: worksheet.rowCount - 0.2 },
//             ext: { width: imgWidth, height: imgHeight }
//           });

//           worksheet.getRow(worksheet.rowCount).height = 100; // Set row height for images
//         } catch (err) {
//           console.error('Image error:', err);
//         }
//       }
//     }

//     // Ensure proper cell alignment and wrapping
//     worksheet.eachRow({ includeEmpty: true }, (row) => {
//       row.eachCell((cell) => {
//         cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
//       });
//     });

//     // Generate Excel buffer and save as file
//     const excelBuffer = await workbook.xlsx.writeBuffer();
//     const blob = new Blob([excelBuffer], {
//       type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
//     });
//     saveAs(blob, fileName);
//   };

//   // If multidimensional, generate separate Excel files for each sub-array
//   if (isMultiDimensional) {
//     for (let i = 0; i < cata.length; i++) {
//       const group = cata[i];
//       const fileName = `${cataName || 'Catalog'}_${i + 1}.xlsx`;
//       await generateExcelFile(group, fileName);
//     }
//   } else {
//     // If flat array, generate a single Excel file
//     const fileName = `${cataName || 'Catalog'}.xlsx`;
//     await generateExcelFile(cata, fileName);
//   }
// };